import { useDownloadPdf } from "@kanda-libs/ks-component-ts";
import { MouseEvent, useCallback } from "react";
import { useSelector } from "react-redux";
import { selectors } from "store";
import jobSelectors from "store/selectors/job";

export interface DownloadPdfButtonPropsHook {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  isSubmitting: boolean;
  status: string;
  isLoading: boolean;
}

export default function useDownloadPdfButtonProps(): DownloadPdfButtonPropsHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const job = useSelector(jobSelectors.getEntity);

  const jobId = job?.id || "";

  const { downloadPdf, isSubmitting } = useDownloadPdf();

  const handleDownload = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      downloadPdf(jobId);
    },
    [jobId, downloadPdf]
  );

  return {
    onClick: handleDownload,
    isSubmitting,
    status: job?.status || "draft",
    isLoading,
  };
}
